import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "default-form form-focus weitlist-form" }
const _hoisted_2 = { class: "form-wrapper" }
const _hoisted_3 = { class: "container-waitlist" }
const _hoisted_4 = { class: "container-waitlist" }
const _hoisted_5 = { class: "container-waitlist" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: "height-limited"
  }, {
    content: _withCtx(() => [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "modal--title" }, "Add to Waitlist", -1)),
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label" }, "Lot size:", -1)),
            _createVNode($setup["SliderLimited"], {
              modelValue: $setup.lotSize,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.lotSize) = $event)),
              minTitle: "Min size",
              minValue: $setup.range?.size?.min,
              maxTitle: "Max size",
              maxValue: $setup.range?.size?.max,
              position: "right",
              units: "m²",
              step: 10
            }, null, 8, ["modelValue", "minValue", "maxValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label" }, "Frontage (width):", -1)),
            _createVNode($setup["SliderLimited"], {
              modelValue: $setup.frontage,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.frontage) = $event)),
              minTitle: "Min size",
              minValue: $setup.range?.frontage?.min,
              maxTitle: "Max size",
              maxValue: $setup.range?.frontage?.max,
              position: "right",
              units: "m",
              step: 1
            }, null, 8, ["modelValue", "minValue", "maxValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label" }, "Budget:", -1)),
            _createVNode($setup["SliderLimited"], {
              modelValue: $setup.budget,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.budget) = $event)),
              minTitle: "Min price",
              minValue: $setup.range?.budget?.min,
              maxTitle: "Max price",
              maxValue: $setup.range?.budget?.max,
              position: "left",
              units: "$",
              step: 10000
            }, null, 8, ["modelValue", "minValue", "maxValue"])
          ])
        ])
      ]),
      _createElementVNode("div", { class: "controls" }, [
        _createElementVNode("button", {
          class: "button default",
          onClick: $setup.onClose
        }, "Cancel"),
        _createElementVNode("button", {
          class: "button default primary save",
          onClick: $setup.submitForm
        }, "Add")
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}